var spireAttach = function(context) {
    var behaviors = Drupal.behaviors;
    for(var i in behaviors) {
        if (behaviors.hasOwnProperty(i) && typeof behaviors[i].attach === 'function') {
            try {
                behaviors[i].attach(context, drupalSettings);
            } catch (e) {
                console.log(e);
            }
        }
    }
};

(function($) {
    $(document).ready(function() {
        spireAttach(document);
    });
})(jQuery);
